import axios from "axios";
import qs from "qs";
import config from "../../utils/config";
import { getAuth0IdToken, loginAuth0WithRedirect } from "../../utils/auth";
import toastr from 'toastr';
import "toastr/build/toastr.min.css";


const axiosInstance = axios.create({
  /*"AzureAd": {
    "Instance": "https://login.microsoftonline.com/",
    "ClientId": "9d029959-3f51-4063-bc9f-29e5bc959e95",
    "TenantId": "eb06985d-06ca-4a17-81da-629ab99f6505" 
  },
  "Logging": {
    "LogLevel": {
      "Default": "Information",
      "Microsoft": "Warning",
      "Microsoft.Hosting.Lifetime": "Information"
    }
  },
  "AllowedHosts": "*",*/
  baseURL: config.PGAPI_URL,
  // baseURL: "http://localhost:8000",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    //"Content-Security-Policy": "style-src 'self' 'unsafe-inline' https://maxcdn.bootstrapcdn.com  https://fonts.googleapis.com;img-src 'self' data:; script-src 'self' 'unsafe-inline';connect-src 'self' *.oktapreview.com *.visualstudio.com *.emerson.com *.azurewebsites.net *.okta.com;",
    Pragma: "no-cache",
  },
  maxRedirects: 5,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: "brackets" });
  },
  timeout: 240000,
});

axiosInstance.interceptors.request.use(
  async config => {
    const idToken = await getAuth0IdToken();
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
      config.headers['X-Token-Type'] = 'auth0';
    }
    return config
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 403) {
      // toastr.error("Session timeout. Redirecting to login.");
      loginAuth0WithRedirect({
        appState: {
          returnTo: window.location.pathname + window.location.search,
        },
      });
      return Promise.reject(error)
    }
    return Promise.reject(error);
  }
);

//for PPA_URL

const aInstance = axios.create({
  baseURL: config.PPA_URL,
  timeout: 60000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

//for ConfigIT

const aconfigITInstance = axios.create({
  baseURL: config.REACT_APP_CONFIGIT,
  timeout: 60000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

//for ORDS

const aORDSInstance = axios.create({
  baseURL: config.ORDS_CREATE_QUOTE_API,
  timeout: 60000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});


//for CADMIN_URL

const axInstance = axios.create({
  baseURL: config.CADMIN_URL,
  timeout: 60000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});
axInstance.interceptors.request.use(
  async config => {
    const idToken = await getAuth0IdToken();
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`;
      config.headers['X-Token-Type'] = 'auth0';
    }
    return config
  }
);

axInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 403) {
      // toastr.error("Session timeout. Redirecting to login.");
      loginAuth0WithRedirect({
        appState: {
          returnTo: window.location.pathname + window.location.search,
        },
      });
      return Promise.reject(error)
    }
    return Promise.reject(error);
  }
);

export const createProjectAPI = (payload) => {
  return axiosInstance
    .post("/wsprjhdr/", payload.payload)
    .then((response) => response)
};

export const copyTagAPI = async (payload) => {
  let technology_name = payload.payload.technology_name, project_id = payload.payload.project_id, package_id = payload.payload.package_id, tag_id = payload.payload.tag_id, pa_ref_id = payload.payload.pa_ref_id;
  delete payload.payload.technology_name;
  delete payload.payload.project_id;
  delete payload.payload.package_id;
  delete payload.payload.tag_id;
  delete payload.payload.pa_ref_id;

  return axiosInstance
    .post("/prjCopyTag/{technology_name,project_id,package_id,tag_id,pa_ref_id}?technology_name=" + encodeURIComponent(technology_name) + '&project_id=' + project_id + '&package_id=' + package_id + '&tag_id=' + tag_id + '&pa_ref_id=' + pa_ref_id, payload.payload.tags)
    .then((response) => response)
};

export const removeTagAPI = async (payload) => {
  let technology_name = payload.payload.technology_name;
  delete payload.payload.technology_name;
  let parent_tag_id = payload.payload.tags[0].parent_tag_id;
  return axiosInstance
    .post("/prjTagRemRef/" + technology_name + "," + parent_tag_id, payload.payload.tags)
    .then((response) => response)
}

// export const createRevisionAPI = (payload) => {
//   console.log('createRevisionAPI=',payload);
//  return axiosInstance
//   .post("/prjCrttagrev", payload)
//   .then((response) => response)
//   .catch(function (error) {
//     if (error.response) {


//       if(error.response.status === 500){
//         console.log(error.response.status);
//         //console.log(payload);
//         createRevisionAPI(payload);

//       }
//       console.log(error.response.headers);
//     }  

//     console.log(error.toJSON());
//   });

// };

export const createRevisionAPI = (data) => {
  // return axiosInstance
  //   .post("/prjStgTagIns/" + data.type, data.recordsArr)
  //   .then((response) => response)
  //   .catch((error) => error);

  return axiosInstance
    .post("/v2/bulk_tags_insert", data.tagsData)
    .then((response) => response)
    .catch((error) => error);

};


// export const createRevisionAPI = async (data) => {
//   try {
//         //const response = await axiosInstance.post("/prjCrttagrev", data.recordsArr).then((response) => response);
//         //const response = await axiosInstance.post("/prjTestTag", data.recordsArr).then((response) => response);


//     //console.log('===========================try data',payload);
//    // const response = await axiosInstance.post("/prjCrttagrev", data).then((response) => response);
//     const response = await axiosInstance.post("/prjStgTagIns", data.recordsArr).then((response) => response);
//    // const response = await axiosInstance.post("/prjTestTag", data).then((response) => response);

//     return response;
//   } catch (e) {
//     console.log('===========================catch payload ',data);
//    // const response = await axiosInstance.post("/prjCrttagrev", data).then((response) => response);

//     const response = await axiosInstance.post("/prjStgTagIns", data.recordsArr).then((response) => response);
//     //const response = await axiosInstance.post("/prjTestTag", data).then((response) => response);

//     return response;
//   }
// };

export const crtedRevDtlsPostAPI = (payload) => {
  return axiosInstance
    .post("/prjPrctagrev/" + payload[0].type, payload)
    .then((response) => response)
    .catch((error) => error)
}

// export const updateRevisionAPI = (payload) =>{
//   return axiosInstance
//     .post("/UpdMultipleTags",payload.payload)
//     .then((response)=>response)
// }

export const updateRevisionAPI = (data) => {
  if (data.from === "singleClickMultiUpdate") {
    return axiosInstance
      .post("/prjUpdtagsts/" + data.type, data.tagsData)
      .then((response) => response)
      .catch((error) => error);
  } else {
    return axiosInstance
      .post("/v2/bulk_tags_update", data.tagsData)
      .then((response) => response)
      .catch((error) => error);
  }
}


export const updtedRevDtlsPostAPI = (payload) => {
  return axiosInstance
    .post("/prjUpdtagrev/" + payload[0].type, payload)
    .then((response) => response)
    .catch((error) => error);
}


export const updateProjectAPI = (payload) => {
  return axiosInstance
    .post("/prjupd/", payload.uProj)
    .then((response) => response)
}


export const getProjectsAPI = (payload) => {
  let str;
  if (payload?.search === 'email' || payload?.payload?.search === 'email') {
    str = `/getPWSHdrs/?eid=${payload.created_by || payload.payload.created_by}`
  }
  else {
    str = `/getPWSHdrs/?pname=${payload?.pname || payload?.payload?.pname}`
  }
  return axiosInstance.get(str).then((response) => (response.data));
}

export const copyProjectAPI = (payload) => {
  return axiosInstance
    .post("/copyprj/", payload.payload)
    .then((response) => response)
}

export const getMasterProjectsAPI = () => {
  return axiosInstance.get('/getMstrPrj').then((response) => response.data);
}

export const getPkgAPI = (payload) => {
  return axiosInstance.get('/gtprpkg/' + payload.payload.aid).then((response) => response.data)
}

export const createPkgAPI = (payload) => {
  return axiosInstance.post('/v2/prjpkgIns', payload.payload).then((response) => response)
  // return axiosInstance.post('http://127.0.0.1:8000/prjpkgIns', payload.payload).then((response) => response)
}
//endpoint for creating tags 
export const createTagAPI = (payload) => {
  return axiosInstance.post('/v3/prjTagsCrt', payload.payload).then((response) => response)
  // return axiosInstance.post('http://127.0.0.1:8000/v3/prjTagsCrt', payload.payload).then((response) => response)
}
//export const getTagsApi = async (payload) => {
// try {
//   const response = await axiosInstance.get('/getprjtags/{pid,pkgid,fromNo,toNo,rid}?pid=' + payload.payload.pid + '&pkgid=' + payload.payload.pkgid + "&rid="+ payload.payload.rid + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo);
//   return response.data;
// } catch (e) {
//   const response = await axiosInstance.get('/getprjtags/{pid,pkgid,fromNo,toNo,rid}?pid=' + payload.payload.pid + '&pkgid=' + payload.payload.pkgid + "&rid="+ payload.payload.rid + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo);
//   return response.data;
// }
//}





//endpoint for getting the tags
export const getTagsApi = (payload) => {

  let signal = payload.signal
  return axiosInstance.get('/v2/getprjtags/{pid,pkgid,tech_type,fromNo,toNo,rid,enable}?pid=' + payload.payload.pid + '&pkgid=' + payload.payload.pkgid + "&rid=" + payload.payload.rid + "&enable=" + payload.payload.enable + "&tech_type=" + encodeURIComponent(payload.techType) + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo, { signal })
    .then((response) => response.data)
    .catch((error) => error);
}

export const deleteTempTags = (payload) => {

  console.log(payload);
  // return axiosInstance.get('/delTagStg/{project_id,package_id,revision,mode,created_by}?project_id=' + payload.pid + '&package_id=' + payload.pkgid + "&revision="+ payload.rid + "&mode=" + payload.mode + "&created_by=" + payload.created_by)
  // .then((response)=>response.data)
  // .catch((error)=> error)
}



//endpoint for updating the tags.
export const updTagAPi = (payload) => {
  return axiosInstance.put('/v2/updtag', payload).then((response) => response)
}

export const chkAccAPI = (payload) => {
  return axInstance.get('/chkappacc/{eid,aid}?eid=' + payload.eid + '&aid=PRJWSC').then((response) => response.data)
}


export const getCapbAPI = (payload) => {
  return axInstance.get('/getcapname/{eid,aname}?eid=' + payload.eid + '&aname=PRJWSC').then((response) => response.data)
}

// User Preference APIs

/**
 * Fetch user preferences
 * @param {string} userId - User ID
 * @returns {Promise} API response
 */
export const getUserPreferenceAPI = (payload) => {
  const { type, email } = payload;
  // TODO: Replace with actual API endpoint
  const dummyUrl = `/get_user_column_preference/?user_email=${email}&preference_key=${type}`;
  return axiosInstance.get(dummyUrl).then((response) => response.data);
}

/**
 * Save user preferences
 * @param {Object} payload - User preference data
 * @param {string} payload.userId - User ID
 * @param {Object} payload.preferences - User General Settings
 * @returns {Promise} API response
 */
export const saveUserPreferenceAPI = (payload) => {
  const { type, email, selectedFields } = payload;
  const preferenceData = {
    user_email: email,
    preference_key: type,
    column: selectedFields
  };

  return axiosInstance.post('/save_user_column_preference', preferenceData)
    .then((response) => response.data);
}


export const getADSearchAPI = (payload) => {
  const searchParam = encodeURIComponent(payload.name);
  return axInstance.get("/getADSrchs/" + searchParam,
  ).then(
    (response) => (response.data)
  )
}


export const crpKGAPI = (payload) => {
  return axiosInstance

    .post("/v2/prjpkgIns/", payload.cPkg)
    // .post("http://127.0.0.1:8000/prjpkgIns/", payload.cPkg)
    .then((response) => response);
};

export const getPkgsAPI = async (payload) => {
  try {
    const response = await axiosInstance
      .get(`/v2/getprpkg?${payload.fPkgs}`);
    //.get(`/getprpkg/{pid,pkgid}?${payload.fPkgs}`);
    // .get(`/getprpkg/{pid,pkgid}?pid=${payload.fPkgs.pid}`);//
    return response;
  } catch (e) {
    const response = await axiosInstance
      .get(`/v2/getprpkg?${payload.fPkgs}`);
    //.get(`/getprpkg/{pid,pkgid}?${payload.fPkgs}`);
    // .get("/getprpkg/" + payload.fPkgs.pid);//
    return response;
  }
};

export const updatePrjAsnAPI = (payload) => {
  return axiosInstance.post("/updprjagn/", payload.payload).then((response => (response.status)))
}

export const getPrjAsnAPI = async () => {
  const response = await axiosInstance.get("/gtprjasn/");
  return (response.data);
}

export const createPrjAsnAPI = (payload) => {
  return axiosInstance.post("/prjasgins/", payload.payload).then((response => (response.status)))
}


export const upPkgAPI = (payload) => {
  return axiosInstance
    .post("/updPkg/", payload.uPkg)
    .then((response) => response)
}

// export const getLPAPI = async (payload) => {
//   const response = await axInstance.get("/v2/getLkpData/" + payload.lname);
//   return (response.data)
// }
export const getLPAPI = async (payload) => {
  try {
    const params = new URLSearchParams();
    payload.lnames.forEach(lname => params.append('lnames', lname));

    const response = await axInstance.get('/v2/getLkpData', {
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const crTechTypeAPI = (payload) => {
  // return axiosInstance.post("/pkgtechtypeins/", payload).then((response) => response);
  return axiosInstance.post("/v2/pkgtechtypeins/", payload).then((response) => response);
}

export const fetchTTAPI = (payload) => {
  return axiosInstance.get('/getpkgtechtype/{pid,pkgid,rid}?pid=' + payload.project_id + '&pkgid=' + payload.package_id + '&rid=' + payload.rid).then((response) => response)
}
export const getPrjCnt = async (eid) => {
  const response = await axiosInstance
    .get("/getprjcnt/" + eid);
  return response;
};

export const getPrjAPI = async (payload) => {
  try {
    const response = await axiosInstance
      .get("/getProj/{eid,fromNo,toNo,buName}?eid=" + payload.eid + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo + "&buName=" + payload.bu_name);
    return response.data;
  } catch (e) {
    const response = await axiosInstance
      .get("/getProj/{eid,fromNo,toNo,buName}?eid=" + payload.eid + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo);
    return response.data;
  }
};
export const getAllPrjAPI = async (payload) => {
  try {
    // if (payload.capabilities.findIndex((o)=>o.PWSALPRJ === 'Y') > 0){
    const response = await axiosInstance
      // .get("/getAllProj/{fromNo,bu_name}?" + "fromNo=" + payload.fromNo + "&bu_name=" + payload.bu_name);
      .get("/getAllProjnew/{fromNo,bu_name}?" + "fromNo=" + payload.fromNo + "&bu_name=" + payload.bu_name);
    return response.data;
    // }
  } catch (e) {
    const response = await axiosInstance
      .get("/getProj/{eid,fromNo,toNo,buName}?eid=" + payload.eid + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo);
    return response.data;
  }
};

export const getTagCnt = async (payload) => {
  return await axiosInstance.get('/v2/gettagcnt/{pid,pkgid,rev,enable}?pid=' + payload.payload.pid + '&pkgid=' + payload.payload.pkgid + '&rev=' + payload.payload.rev + '&enable=' + payload.payload.enable).then(response => response)
};


export const getActiveAppAPI = () => {
  return axInstance.get("/getAppsAR/").then((response) => (response.data))
}

export const getConfigDetails = ({ config_header_id, config_rev_num, division_code, tag_id }) => {
  let paramJson = {
    "application": "PRJWS",
    "source": "QUOTE",
    config_header_id,
    config_rev_num,
    division_code,
    tag_id
  }
  return axiosInstance.get("/getPriceConfigRecords/", { params: paramJson }).then((response) => (response.data))
}
export const createDuplicateLineAPI = (payload) => {
  return axiosInstance.post("/dummytest-duplicate-line/", payload.payload).then((response) => (response))
}

// export const getModelBreak = async (payload) => {
//   console.log("getModelBreak start", payload);

//   const url = `/getModelBreak/{p_application,p_technology_name,p_tag_id}?p_application=${payload.p_application}&p_technology_name=${payload.p_technology_name}&p_tag_id=${payload.p_tag_id}`;

//   return axiosInstance.get(url)
//     .then((response) => response.data)
//     .catch((error) => {
//       console.error('Error:', error);
//       if (error.response) {
//         console.error('Response data:', error.response.data);
//       }
//       throw error; // Re-throw the error to propagate it to the calling code
//     });
// };

// export const getModelBreak = async (payload) => {
//   console.log("getModelBreak start", payload);


//  // const parsedTagId = parseInt(payload.p_tag_id, 10);

//   const url = `/getModelBreak/{p_application,p_technology_name,p_tag_id}?p_application='PRJWS'&p_technology_name=${payload.p_technology_name}&p_tag_id=${payload.p_tag_id}`;

//   try {
//     const response = await axiosInstance.get(url);
//     return response.data;
//   } catch (error) {
//     console.error('Error:', error);
//     throw error; 
//   }
// };

export const getModelBreak = async (data) => {
  const { payload } = data;
  try {
    const response = await axiosInstance.get(
      `/getModelBreak/{p_application,p_technology_name,p_tag_id}`,
      {
        params: {
          p_application: payload.p_application,
          p_technology_name: payload.p_technology_name,
          p_tag_id: payload.p_tag_id,
        },
      }
    );
    console.log(response, "response")
    return response;
    console.log(response.data);
  } catch (e) {
    console.log('Error:', e);
  }
};

export const addUpdatePriceConfig = (payload) => {
  return axiosInstance.post("/addUpdPriceConfigRecords", payload).then((response) => (response))
}

export const postReportBatchesAPI = (payload) => {
  return axiosInstance.post("/report-batches", payload).then((response) => response)
}

export const getReportBatchesAPI = (payload) => {
  return axiosInstance.get("/report-batches", { params: payload }).then((response) => response.data)
}

export const getReportBatchByIdAPI = (batchId) => {
  return axiosInstance.get(`/report-batches/${batchId}`).then((response) => response.data)
}

export const downloadReportBatchAPI = (batchId) => {
  return axiosInstance.get(`/report-batches/${batchId}/download`, {
    responseType: "blob",
  })
}

export const getReportBatchQueuePositionAPI = (batchId) => {
  return axiosInstance.get(`/report-batches/${batchId}/queue-position`).then((response) => response.data)
}

export const getReportAPI = async (payload) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // "Ocp-Apim-Subscription-Key": process.env.REACT_APP_REPORT_API_SUBSCRIPTION_KEY,
    },
    body: JSON.stringify(payload.payload),
  };
  const res = await fetch(
    `${config.REPORT_API_URL}/reports/`,
    requestOptions
  );
  const response = await res.json();
  return response;
}

export const getRptHubTkStt = async (payload) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      // "Ocp-Apim-Subscription-Key": process.env.REACT_APP_REPORT_API_SUBSCRIPTION_KEY,
    },
  };
  const res = await fetch(
    `${config.REPORT_API_URL}/reports/${payload}/status/`,
    requestOptions
  );
  const response = await res.json();
  return response;
}

export const reportHubStatus = (payload) => {
  return axiosInstance.post("/tagRepHubStsIns/", payload).then((response) => (response))
}

export const getReportHubStatus = (payload) => {
  let pl = payload.payload;
  return axiosInstance.get('/gettagRepHubSts/{pid,pkgid,rid,request_by}?request_by=' + pl.request_by).then((response) => (response))
}

export const reportHubStatusUpd = (payload) => {
  return axiosInstance.post("/tagRepHubStsUpd/", payload).then((response) => (response))
}

export const emailNotiSendAPI = (payload) => {
  return axInstance.post("/sendmail/", payload.payload).then((response => (response.status)))
}
// export const getModelBreakMultiTag = async (data) => {
//   const { payload } = data;
//   try {
//     const response = await axiosInstance.post(
//       //  'getModelBreakMultiTag/%7Bp_application,p_technology_names,p_tag_ids%7D?p_application=PRJWS',
//       `getModelBreakMultiTag/{p_application,p_technology_names,p_tag_ids}?p_application=${payload.p_application}`,
//       {
//         p_technology_names: payload.p_technology_names,
//         p_tag_ids: payload.p_tag_ids,
//       }
//     );
//     console.log(response, "response");
//     return response;
//     console.log(response.data);
//   } catch (e) {
//     console.log("Error:", e);
//   }
// };

export const getModelBreakMulTag = async (data) => {
  const { payload } = data;
  try {
    // console.log("payload in pgapis",payload)
    const response = await axiosInstance.post(
      '/getModelBreakMulTag/', payload
    );
    //console.log(response, "response");
    return response;
  } catch (e) {
    // console.log('Error:', e);
    throw e;
  }
};

export const getProjectForCopyAPI = (srchToken, bu) => {
  return axiosInstance.get(`/getPWSHdrs/?pname=${srchToken}&buName=${bu}`).then((response) => (response.data))
}



export const bulkConfigtagsstus = (payload) => {

  let signal = payload.signal
  return axiosInstance.get(`/bulk-tag-confg?project_id=${payload.project_id}&package_id=${payload.package_id}&revision=${payload.revision}`, { signal })
    .then((response) => response)
    .catch((error) => error)
}

export const postBulkConfigtag = (payload) => {
  return axiosInstance
    .post("/bulk-tag-confg", payload)
    .then((response) => response)
    .catch((error) => error);
}

export const cancelBulkConfigtag = (payload) => {
  return axiosInstance
    .put("/bulk-tag-confg-canceling", payload)
    .then((response) => response)
    .catch((error) => error);
}

// let Authtoken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken?.idToken

// const config11 = {
//   headers: { Authorization: `Bearer ${Authtoken}` }
// };



// export const postBulkConfigtag = async (payload) => {
//   var session_url = 'http://localhost:8000/bulk-tag-confg';

//   console.log(payload)
//   try {
//     // console.log("payload in pgapis",payload)
//     const response = await axios.post(session_url, payload, config11);
//     //console.log(response, "response");
//     return response;
//   }
//   catch (e) {
//     console.log('Error:', e);
//     throw e;
//   }
// };

// export const bulkConfigtagsstus = async (payload) => {
//   var session_url = 'http://localhost:8000/bulk-tag-confg';

//   console.log(payload)
//   try {
//     // console.log("payload in pgapis",payload)
//     const signal = payload.signal
//     const response = await axios.get(`${session_url}?project_id=${payload.project_id}&package_id=${payload.package_id}`, { signal }, config11);
//     //console.log(response, "response");
//     return response;
//   }
//   catch (e) {
//     console.log('Error:', e);
//     throw e;
//   }
// };

// export const cancelBulkConfigtag = async (payload) => {
//   var session_url = 'http://localhost:8000/bulk-tag-confg-canceling';

//   console.log(payload)
//   try {
//     // console.log("payload in pgapis",payload)
//     const response = await axios.put(session_url, payload, config11);
//     //console.log(response, "response");
//     return response;
//   }
//   catch (e) {
//     console.log('Error:', e);
//     throw e;
//   }
// };


//--------api for posting pricing-----------
export const pricingAPI = async (payload) => {
  return await aInstance.post('/costing-workspace-create', payload)
    .then((response) => response)
    .catch((error) => error);

};
// export const pricingAPI = (payload) =>{
//   return axios.post("https://ppafapi-dev.azurewebsites.net/costing-workspace-create/",payload.payload).then((response => (response.status)))
//  }
export const paGetSizingAPI = async (paRefId, technologyName) => {
  try {
    const response = await axiosInstance.get(`/paGetSizingApi/{pa_ref_id,technology_name}?pa_ref_id=${paRefId}&technology_name=${technologyName}`)
    return response
  } catch (e) {
    return e.response.data
  }
}

export const itemPriceSubmitApi = async (payload) => {
  return axiosInstance
    .post("/item-price", payload.payload)
    // .post("http://127.0.0.1:8000/item-price", payload.payload)
    .then((response) => response)
    .catch((error) => error);
}

export const itemPriceStatusApi = async (payload) => {

  return axiosInstance.get(
    '/item-price-status',
    // 'http://127.0.0.1:8000/item-price-status',
    {
      params: {
        project_id: payload.project_id,
        package_id: payload.package_id,
        revision: payload.revision
      },
      signal: payload.signal
    })
    .then((response) => response)
    .catch((error) => error)
}

export const getModelConfigApi = async (payload) => {
  return axiosInstance
    .post("/model-config", payload)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getModelConfigDetailsApi = async (payload) => {
  return axiosInstance
    .post("/config-details", payload)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getPricingByHeaderIdApi = async (config_header_id, config_rev_nbr) => {
  return axiosInstance
    .get("/pricing-details-by-header-id", {
      params: {
        config_header_id: config_header_id,
        config_rev_nbr: config_rev_nbr
      }
    })
    .then((response) => response.data)
    .catch((error) => error);
}

export const quoteSearchApi = async (payload) => {
  return axiosInstance
    .get("/searchbyquotenumber", {
      params: payload
    })
    .then((response) => response.data)
    .catch((error) => error);
}

export const getEntRole = async (payload) => {
  return axInstance
    .get(`/get-ent-commerce-roles/?activeOrgId=${payload.activeOrgId}&obo=${payload.obo}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getTagsApiWithRemarks = (payload) => {

  console.log("calling API with remarks")
  const ridQuery = payload.rev != null ? `&rid=${payload.rev}` : '';
  return axiosInstance.get('/v2/getprjtags_with_remarks/{pid,pkgid,fromNo,toNo,rid,enable}?pid=' + payload.project_id + '&pkgid=' + payload.package_id + "&fromNo=" + payload.fromNo + "&toNo=" + payload.toNo + ridQuery + "&enable=" + payload.enable, { signal: payload.signal })
    .then((response) => response)
    .catch((error) => error);
}

export const getPkgHistoryCmnt = (payload) => {
  return axiosInstance.get(`/getPkg_cmt_history?pid=${payload.project_id}`)
    .then((response) => response)
    .catch((error) => error);
}

export const updateNotificationAPI = (payload) => {
  return axiosInstance
    .post("/updateNotification", payload)
    .then((response) => response)
    .catch((error) => error);
}
export const getUnreadNotificationAPI = (email) => {

  return axiosInstance.get(`/getNotifications?email=${email}`)
    .then((response) => response)
    .catch((error) => error);
}

export const updatePkgRevComment = (payload) => {
  return axiosInstance
    .post("/pkgRevComment", payload)
    .then((response) => response)
    .catch((error) => error);
}

export const getConfRoutingDetailsAPI = (payload) => {
  console.log("getConfRoutingDetailsAPI payload", payload)
  return aconfigITInstance
    .post("/api/v1/main/preconfig/getroutingdetails", payload)
    .then((response) => response)
    .catch((error) => error);
}

export const getConfSessionIDAPI = (payload) => {
  console.log("getConfSessionIDAPI payload", payload)
  return aconfigITInstance
    .post("/api/v1/main/quote2configurator", payload)
    .then((response) => response)
    .catch((error) => error);
}

export const confCreateQuoteAPI = (payload) => {
  return aORDSInstance
    .post("/ords/betsy/v1.0/PRJWSACTIONS/createQuote", payload)
    .then((response) => response)
    .catch((error) => error);
};

export const confUpdateQuoteAPI = (payload) => {
  return aORDSInstance
    .post("/ords/betsy/v1.0/PRJWSACTIONS/updateQuote", payload)
    .then((response) => response)
    .catch((error) => error);
};



export const editPkgRevComment = (payload) => {
  return axiosInstance
    .post("/editPkgRevComment", payload)
    .then((response) => response)
    .catch((error) => error);
}

export const confITModelBreakdownAPI = (payload) => {
  return axiosInstance
    .post("/configit_validate_modelstring_breakdown", payload)
    .then((response) => response)
    .catch((error) => error);
}

